import * as React from 'react';
import Help from '@material-ui/icons/Help';
import IconButton from '@material-ui/core/IconButton';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';

interface HelpButtonProps {
    anchor?: string;
}

type Props = HelpButtonProps & typeof goActions;

const HelpButton: React.SFC<Props> = (props) => {

    const link = `/help${props.anchor ? "#" + props.anchor : ""}`;

    return <IconButton onClick={(e) => props.goTo(link)}><Help color="primary" /></IconButton>
}

const goActions = {
    goTo: (location: string) => push(location)
};

export default connect(null, goActions)(HelpButton);


// WEBPACK FOOTER //
// ./src/help/HelpButton.tsx